import { render, staticRenderFns } from "./GDateSelector.vue?vue&type=template&id=ca3e3de0&scoped=true"
import script from "./GDateSelector.vue?vue&type=script&lang=js"
export * from "./GDateSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3e3de0",
  null
  
)

export default component.exports